import React, { useEffect, useState } from 'react'
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import HorizontalProgressBar from '../../../components/progressbar/HorizontalProgressBar'
import Label from '../../../components/label/Label'
import PageBody from '../../../components/pagebody/PageBody'
import { componentKey, setAssigneeList, setEncryptedNoticeID, setExportFile } from './ViewNoticeSectionSlice'
import { useDispatch, useSelector } from 'react-redux'
import { downloadNoticeDocument, downloadTaskDocument, getAssigneeList, getNotice, getTaskList, getTaskStatusList, inviteClient, removeNotice, removeNoticeDocument, removeNoticeNote, removeNoticeTask, removeTaskDocument, removeTaskNote, saveNoticeNote, saveTask, saveTaskNote, uploadNoticeDocument, uploadTaskDocument } from './ViewNoticeSectionSaga'
import Button from '../../../components/button/Button'
import { BUTTON_TYPE } from '../../../components/button/constants'
import BasicCard from '../../../components/card/basiccard/BasicCard'
import Popup from '../../../components/popup/Popup'
import Icons from '../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../components/icons/constants'
import Accordion from '../../../components/accordion/Accordion'
import styles from './ViewNotice.styles';
import { ADD_CLIENT, ADD_NOTE, ADD_TASK, UPLOAD_FILES } from './constants'
import { LABEL_WEIGHT } from '../../../components/label/constants'
import MultiSelectDropdownWLabel from '../../../components/dropdown/multiselectdropdownwlabel/MultiSelectDropdownWLabel'
import SelectDropdown from '../../../components/dropdown/selectdropdown/SelectDropdown'
import General from '../../../../libs/utility/General'
import TextExpansion from '../../../components/textexpansion/TextExpansion'
import FileUpload from '../../../components/fileupload/FileUpload'
import HorizontalSeparator from '../../../components/separator/horizontalSeparator/HorizontalSeparator'
import IconDropdown from '../../../components/dropdown/icondropdown/IconDropdown'
import TextInput from '../../../components/input/textinput/TextInput'
import CalendarInputWDateFormat from '../../../components/input/calendarinput/CalendarInputWDateFormat';
import RichTextEditor from 'react-rte'
import Loadable from '../../../components/loadable/Loadable'
import DateUtils from '../../../../libs/utility/DateUtils'
import { PermissionReroute, useUserPermissionsInfo } from '../../dashboard/hooks/userHooks'
import { PAGE_PATH, PAGE_PERMISSIONS } from '../../dashboard/constants/constant'
import { COMMON_LOADING_STATES, COMMON_LOADING_STATES_MESSAGE_MAP, NOTICE_SECTION_ROUTES } from '../../constants/constants'
import useTxSearchParams from '../../../../libs/txsearchparams/TxSearchParamsHook'
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook'
import Breadcrumbs from '../../../components/breadcrumbs/Breadcrumbs'

export default function ViewNotice() {
	const { loadingState, noticeDetail, exportFile, payerDetails, noticeNotes, noticeTasksList, noticeDocumentList, clientList, invitedAssigneeList, assigneeList, taskStatusList, encryptedNoticeID } = useSelector((state) => state[componentKey])
	const [queryParams, setQueryParams] = useTxSearchParams();
	const [showPopup, setShowPopup] = useState(false);
	const [popupTitle, setPopupTitle] = useState("");
	const [popupBodyComponent, setPopupBodyComponent] = useState("");
	const [newNoteDescription, setNewNoteDescription] = useState("");
	const NONE_SELECTED = "None Selected";
	const [selectedAssigneeLabel, setSelectedAssigneeLabel] = useState(NONE_SELECTED);
	const [uploadedFile, setUploadedFile] = useState(null);
	const [selectedTask, setSelectedTask] = useState(null);
	const [taskDetails, setTaskDetails] = useState({});
	const { permissions } = useUserPermissionsInfo();

	const dispatch = useDispatch();
	const navigate = useTxNavigate();
	
	useEffect(()=>{
        PermissionReroute(PAGE_PERMISSIONS.VIEW_NOTICES, permissions, navigate, PAGE_PATH.DASHBOARD)
    },[permissions])

	useEffect(() => {
		const noticeid = queryParams.get('NoticeID');
		if (noticeid !== '' || noticeid !== undefined) {
			dispatch(setEncryptedNoticeID(noticeid))
			dispatch(getNotice({ noticeid }))
			dispatch(getTaskList({ noticeid }))
			dispatch(getTaskStatusList())
		}
	}, [window.location])

	useEffect(() => {
		if (payerDetails && invitedAssigneeList) {
			dispatch(getAssigneeList({ noticeid: encryptedNoticeID, payerId: payerDetails?.PayerDetailId, invitedAssigneeList }))
		}
	}, [invitedAssigneeList])

	useEffect(() => {
		if (exportFile) {
			General.downloadFile(exportFile.Base64, exportFile.Name, exportFile.MimeType)
			dispatch(setExportFile(null))
		}
	}, [exportFile])

	const handleRemoveNoticeNote = (e, NoticeNoteID) => {
		e.stopPropagation();
		dispatch(removeNoticeNote({ NoticeNoteID, noticeid: encryptedNoticeID }))
	}

	const handleRemoveNoticeDocument = (e, NoticeDocumentID) => {
		e.stopPropagation();
		dispatch(removeNoticeDocument({ NoticeDocumentID, noticeid: encryptedNoticeID }))
	}

	const getIcon = (fileExtension) => {
		switch (fileExtension) {
			case '.pdf':
				return <Icons familyName={'vec'} iconName={VEC_ICON_NAME.PDF_ICON} />
			case '.docx':
			case '.doc':
				return <Icons familyName={'vec'} iconName={VEC_ICON_NAME.PDF_ICON} />
			default:
				return <Icons familyName={'vec'} iconName={VEC_ICON_NAME.PDF_ICON} />
		}
	}

	const handleAdd = (name) => {
		setPopupTitle(name);
		setShowPopup(true)
		setPopupBodyComponent(name)
	}

	const getAddNotePopupField = () => {
		return (
			<div style={styles.addNotePopupField}>
				<Label weight={LABEL_WEIGHT[700]}>Description</Label>
				<textarea style={{ ...styles.fullWidth, ...styles.minHeight200 }} value={newNoteDescription} onChange={(e) => setNewNoteDescription(e.target.value)} />
			</div>
		)
	}

	const handleMultiSelectChange = (option, index) => {
		dispatch(setAssigneeList(option))
		setSelectedAssigneeLabel(`${option.filter(opt => opt.checked)?.length ?? 'None'} Selected`)
	}

	const getAddTaskField = () => {

		const toolbarConfig = {
			display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
			INLINE_STYLE_BUTTONS: [
			  {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
			  {label: 'Italic', style: 'ITALIC'},
			  {label: 'Underline', style: 'UNDERLINE'}
			],
			BLOCK_TYPE_DROPDOWN: [
			  {label: 'Normal', style: 'unstyled'},
			  {label: 'Heading Large', style: 'header-one'},
			  {label: 'Heading Medium', style: 'header-two'},
			  {label: 'Heading Small', style: 'header-three'}
			],
			BLOCK_TYPE_BUTTONS: [
			  {label: 'UL', style: 'unordered-list-item'},
			  {label: 'OL', style: 'ordered-list-item'}
			]
		  };

		return (
			<div style={styles.addTaskPopupField}>
				<div>
					<Label>*Task Name</Label>
					<TextInput
						value={taskDetails?.taskName}
						onChangeCb={(e) => setTaskDetails(prev => ({ ...prev, taskName: e.target.value }))}
					/>
				</div>
				<div>
					<Label>Description</Label>
					<RichTextEditor
						toolbarConfig={toolbarConfig}
						editorStyle={styles.height200}
						value={taskDetails?.description || RichTextEditor.createEmptyValue()}
						onChange={(value) => setTaskDetails(prev => ({ ...prev, description: value }))}
					/>
				</div>
				<div>
					<Label>Due Date</Label>
					<CalendarInputWDateFormat
						label={"Select due date"}
						name='dueDate'
						value={taskDetails?.dueDate}
						onChangeCb={(e) => setTaskDetails(prev => ({ ...prev, dueDate: e }))}
					/>
				</div>
				<div>
					<Label>Notice Type</Label>
					<SelectDropdown
						name="select"
						value={taskStatusList.find(status => status.value === taskDetails?.noticeType) ?? taskStatusList[0]}
						prefixProps={{ text: "" }}
						onSelectCb={(name, selectedOption) => setTaskDetails(prev => ({ ...prev, noticeType: selectedOption.value }))}
						options={taskStatusList}
						isClearable={false}
					/>
				</div>
			</div>
		)
	}

	const submitPopup = (customPopupBodyComponent = null, customTaskDetail = null) => {
		let popupBodyComponentLocal = popupBodyComponent;

		if (customPopupBodyComponent) {
			popupBodyComponentLocal = customPopupBodyComponent
		}
		switch (popupBodyComponentLocal) {
			case ADD_CLIENT:
				const selectedAssignee = assigneeList.filter(option => option.checked);
				if (selectedAssignee.length > 0) {
					dispatch(inviteClient({
						data: {
							NoticeID: noticeDetail.NoticeID,
							Assignees: selectedAssignee.map(assignee => parseInt(assignee.value)).join(',')
						},
						noticeid: encryptedNoticeID
					}))
				}
				break;
			case ADD_NOTE:
				if (selectedTask) {
					dispatch(saveTaskNote(
						{
							data: {
								NoticeTaskNoteID: 0,
								NoticeTaskID: selectedTask?.NoticeTasksID,
								Description: newNoteDescription
							},
							noticeid: encryptedNoticeID
						}
					))
				} else {
					dispatch(saveNoticeNote(
						{
							data: {
								NoticeNoteID: 0,
								NoticeID: noticeDetail.NoticeID,
								Description: newNoteDescription
							},
							noticeid: encryptedNoticeID
						}
					))

				}
				break;
			case UPLOAD_FILES:
				if (selectedTask) {
					dispatch(uploadTaskDocument(
						{
							NoticeTaskID: selectedTask?.NoticeTasksID,
							uploadFile: uploadedFile,
							noticeid: encryptedNoticeID
						}
					))
				} else {
					dispatch(uploadNoticeDocument(
						{
							NoticeID: noticeDetail.NoticeID,
							uploadFile: uploadedFile,
							noticeid: encryptedNoticeID
						}
					))
				}
				break;
			case ADD_TASK:
				let taskDetailsObj = taskDetails

				if (customTaskDetail) {
					taskDetailsObj = customTaskDetail
				}

				dispatch(saveTask(
					{
						noticeDetails: {
							NoticeTaskID: taskDetailsObj?.NoticeTaskID,
							NoticeID: noticeDetail.NoticeID,
							TaskName: taskDetailsObj?.taskName || '',
							TaskDescription: taskDetailsObj?.description ? taskDetailsObj?.description.toString('html') : '',
							TaskDueDate: taskDetailsObj?.dueDate || '',
							TaskStatus: taskDetailsObj?.noticeType ? parseInt(taskDetailsObj?.noticeType) : taskStatusList[0].value
						},
						noticeid: encryptedNoticeID

					}
				))
		}
		resetSubmitPopup();
	}

	const resetSubmitPopup = () => {
		setShowPopup(false)
		setSelectedTask(null)
		setTaskDetails({})
		switch (popupBodyComponent) {
			case ADD_CLIENT:
				dispatch(setAssigneeList([]));
				break;
			case ADD_NOTE:
				setNewNoteDescription("");
				break;
			case UPLOAD_FILES:
				setUploadedFile(null);
				break;
		}
		setPopupBodyComponent(null);
	}

	const getClientPopupField = () => {
		return (
			<div style={styles.clientPopupField}>
				<Label weight={LABEL_WEIGHT[700]}>*Assignee(s):</Label>
				<MultiSelectDropdownWLabel 
					label={selectedAssigneeLabel}
					options={assigneeList}
					onChangeCheckboxCb={(options, index) => handleMultiSelectChange(options, index)}
					buttonProps={[]}
				/>
			</div>
		)
	}

	const handleUploadedFileChange = (event) => {
		event.preventDefault();
		const file = event.target.files[0];
		const fileExtension = file.name.split('.').pop().toLowerCase();

		if (allowedFileTypes.includes(`.${fileExtension}`)) {
			if (file) {
				setUploadedFile(file);
			}
		} else {
			dispatch(addNotifications({ heading: "File format not supported", message: "Invalid file format. Please upload a .xlsx or .csv file." }));
		}
		event.target.value = null;
	};

	const handleDrop = (event) => {
		event.preventDefault();
		const file = event.dataTransfer.files[0];

		const fileExtension = file.name.split('.').pop().toLowerCase();

		if (allowedFileTypes.includes(`.${fileExtension}`)) {
			setUploadedFile(file);

		} else {
			dispatch(addNotifications({
				heading: "File format not supported",
				message: `Invalid file format. Please upload a ${allowedFileTypes.join(", ")} file.`
			}));
		}
	};

	const allowedFileTypes = ['.pdf', '.doc', '.docx'];

	const getUploadDocumentField = () => {
		return (
			<FileUpload
				uploadedFile={uploadedFile}
				onDropCb={handleDrop}
				allowedFileType={allowedFileTypes}
				onInputChangeCb={handleUploadedFileChange}
			/>
		)
	}

	const getPopupBody = () => {
		switch (popupBodyComponent) {
			case ADD_NOTE:
				return getAddNotePopupField();
			case ADD_CLIENT:
				return getClientPopupField();
			case UPLOAD_FILES:
				return getUploadDocumentField();
			case ADD_TASK:
				return getAddTaskField();
		}
	}

	const handleSelectedOptionChange = (name, selectedOption, task) => {
		submitPopup(ADD_TASK, {
			NoticeTaskID: task.NoticeTasksID,
			taskName: task.TaskName,
			description: RichTextEditor.createValueFromString(task?.TaskInstruction || '<p><br></p>', 'html'),
			dueDate: task.DueDate,
			noticeType: selectedOption.value
		});
	}

	const getTaskOptions = (task) => {
		return [
			{ itemName: "Edit", onClick: () => handleEditTask(task) },
			{ itemName: "Delete", onClick: () => handleDeleteTask(task) },
		]
	}

	const handleDeleteTask = (task) => {
		dispatch(removeNoticeTask({
			NoticeTaskID: task.NoticeTasksID,
			noticeid: encryptedNoticeID,
		}))
	}

	const handleEditTask = (task) => {
		setShowPopup(true),
			handleAdd(ADD_TASK)
		setTaskDetails({
			NoticeTaskID: task.NoticeTasksID,
			taskName: task.TaskName,
			description: RichTextEditor.createValueFromString(task?.TaskInstruction || '<p><br></p>', 'html'),
			dueDate: task.DueDate,
			noticeType: task.TaskStatus
		})
	}

	const getTaskheader = (task) => {
		return (
			<div style={styles.taskHearder}>
				<div>{task?.TaskName}</div>
				<div>{DateUtils.dateFormatter(task?.DueDate, "MMM DD, YYYY")}</div>
				<div onClick={(e) => e.stopPropagation()}>
					<SelectDropdown
						name="select"
						value={taskStatusList.find(option => parseInt(option.value) === task?.TaskStatus) ?? taskStatusList[0]}
						prefixProps={{ text: "" }}
						onSelectCb={(name, selectedOption) => handleSelectedOptionChange(name, selectedOption, task)}
						options={taskStatusList}
						isClearable={false}
					/>
				</div>
				<div style={styles.ellipsisBox}>
					<IconDropdown showToggle={false} iconName={VEC_ICON_NAME.HORIZONTAL_ELLIPSIS} dropdownItems={getTaskOptions(task)} />
				</div>
			</div>
		)
	}

	const getTaskBody = (task) => {
		return (
			<div style={styles.taskBody}>
				<TextExpansion>
					<div dangerouslySetInnerHTML={{ __html: General.sanitizeContent(task?.TaskInstruction ?? '') }} style={styles.colorBlack} />
				</TextExpansion>
				<HorizontalSeparator />
				<div style={styles.taskBodyAddRows}>
					<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => {
						setSelectedTask(task);
						handleAdd(UPLOAD_FILES);
					}}>Add File</Button>
					<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => {
						setSelectedTask(task);
						handleAdd(ADD_NOTE);
					}}>Add Note</Button>
				</div>
				<Heading type={HEADING.H3}>Files</Heading>
				{task?.NoticeTask.Documents.map(document =>
					<div onClick={() => handleDownloadDocument(document)}>
						<BasicCard customStyles={styles.cursorPointer} fullWidth={true} isHighlighted={true} circularCheckboxStyles={styles.displayNone} isRemoveable={true} onRemoveCB={(e) => handleRemoveTaskDocument(e, document.NoticeTaskDocumentID)} >
							<div style={styles.documentBody}>
								{getIcon(document.Extension)}
								{document.FileName}
							</div>
						</BasicCard>
					</div>
				)}
				<Heading type={HEADING.H3}>Note</Heading>
				{task?.NoticeTask.Notes.map(note =>
					<BasicCard fullWidth={true} isHighlighted={true} circularCheckboxStyles={styles.displayNone} isRemoveable={true} onRemoveCB={(e) => handleRemoveTaskNote(e, note.NoticeTaskNoteID)} >
						<p>Added by {note.FirstName} {note.LastName}</p>
						{note.Description}
					</BasicCard>
				)}
			</div>
		)
	}

	const handleRemoveTaskNote = (e, NoticeTaskNoteID) => {
		dispatch(removeTaskNote({ NoticeTaskNoteID, noticeid: encryptedNoticeID }))
	}

	const handleRemoveTaskDocument = (e, NoticeTaskDocumentID) => {
		dispatch(removeTaskDocument({ NoticeTaskDocumentID, noticeid: encryptedNoticeID }))
	}

	const handleDownloadDocument = (document) => {
		if ('NoticeTaskDocumentID' in document) {
			dispatch(downloadTaskDocument({ NoticeTaskDocumentID: document.NoticeTaskDocumentID }))
		} else {
			dispatch(downloadNoticeDocument({ NoticeDocumentID: document.NoticeDocumentID }))
		}
	}



	return (
		<>
		<Breadcrumbs items={[
                        { text: 'Home', link: '/' },
                        { text: 'Notices', link: `/${NOTICE_SECTION_ROUTES.NOTICE}` },
                        { text: 'View Notice' },
                    ]} 
                />
		<PageBody>
			<Loadable currentState={loadingState.state} loadingStates={[COMMON_LOADING_STATES.GENERAL_LOADING]} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
				<div style={styles.mainContainer}>
					<div style={styles.leftContainer}>
						<div style={styles.leftContainerHeader}>
							<Heading type={HEADING.H1}>Progress</Heading>
							<HorizontalProgressBar iconName={null} value={noticeTasksList?.filter(task => task.TaskStatus === 5).length} maxValue={noticeTasksList?.length ?? 0} />
							<div style={styles.progressSubLabels}>
								<Label>{noticeTasksList?.filter(task => task.TaskStatus === 5).length}/{noticeTasksList?.length} Tasks Completed</Label>
								<Label>Date {noticeDetail?.DueDate}</Label>
							</div>
						</div>
						<div>
							<TextExpansion>
								<div dangerouslySetInnerHTML={{ __html: General.sanitizeContent(noticeDetail?.Message ?? '') }} />
							</TextExpansion>
						</div>
						<div style={styles.taskSection}>
							<div style={styles.sectionHeader}>
								<Heading type={HEADING.H2}>Tasks List</Heading>
								<Button onClickCb={() => handleAdd(ADD_TASK)}>{ADD_TASK}</Button>
							</div>
							{noticeTasksList?.map(task => <Accordion header={getTaskheader(task)} body={getTaskBody(task)} />)}
						</div>

					</div>
					<div style={{ ...styles.flexOne, ...styles.sectionColumn }}>
						<div style={styles.sectionStyle}>
							<div style={styles.sectionHeader}>
								<Heading type={HEADING.H2}>Add Client</Heading>
								<Button onClickCb={() => handleAdd(ADD_CLIENT)}>{ADD_CLIENT}</Button>
							</div>
						</div>

						<div style={styles.sectionStyle}>
							<div style={styles.payerColumn}>
								<Heading type={HEADING.H2}>Payer Details</Heading>
								<p><span style={styles.fontBold}>{payerDetails?.LastName}</span></p>
								<p><span style={styles.fontBold}>Address:</span> {payerDetails?.Address1}</p>
								<p><span style={styles.fontBold}>Phone no:</span> {payerDetails?.PhoneNumber}</p>
								<p><span style={styles.fontBold}>Email ID:</span> {payerDetails?.Email}</p>
							</div>
						</div>

						<div style={{ ...styles.sectionStyle, ...styles.sectionColumn }}>
							<div style={styles.sectionHeader}>
								<Heading type={HEADING.H2}>Notes</Heading>
								<Button onClickCb={() => handleAdd(ADD_NOTE)}>{ADD_NOTE}</Button>
							</div>
							{noticeNotes?.map(note =>
								<BasicCard fullWidth={true} isHighlighted={true} circularCheckboxStyles={styles.displayNone} isRemoveable={true} onRemoveCB={(e) => handleRemoveNoticeNote(e, note.NoticeNoteID)} >
									<p>Added by {note.FirstName} {note.LastName}</p>
									{note.Description}
								</BasicCard>
							)}
						</div>

						<div style={{ ...styles.sectionStyle, ...styles.sectionColumn }}>
							<div style={styles.sectionHeader}>
								<Heading type={HEADING.H2}>Files</Heading>
								<Button onClickCb={() => handleAdd(UPLOAD_FILES)}>{UPLOAD_FILES}</Button>
							</div>
							{noticeDocumentList?.map(document => <div onClick={() => handleDownloadDocument(document)}>
								<BasicCard fullWidth={true} customStyles={styles.cursorPointer} isHighlighted={true} circularCheckboxStyles={styles.displayNone} isRemoveable={true} onRemoveCB={(e) => handleRemoveNoticeDocument(e, document.NoticeDocumentID)} >
									<div style={styles.documentBody}>
										{getIcon(document.Extension)}
										{document.FileName}
									</div>
								</BasicCard>
							</div>
							)}

						</div>
					</div>
				</div>
				<Popup title={popupTitle} onCloseCb={resetSubmitPopup} isPopupOpen={showPopup} customPopupSyles={styles.popupCustomStyle} childrenStyles={styles.popupChildrenStyles}>
					{getPopupBody()}
					<div style={styles.popupFooterButton}>
						<Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => submitPopup()}>Save</Button>
						<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={resetSubmitPopup}>Cancel</Button>
					</div>
				</Popup>
			</Loadable>
		</PageBody>
		</>
		
	)
}